module.exports = __webpack_public_path__ + "img/circle_dna_w.b5a479c3.svg";